export const GET_USER = "GET_USER";
export const SET_USER = "SET_USER";
export const GET_MEMBER_PROFILE = "GET_MEMBER_PROFILE";
